<template>
  <!-- 修改订单 -->
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="1"></el-tab-pane>
        <el-tab-pane name="2">
          <span slot="label">
            未处理
            <i class="red" v-if="tableData.state_1&&tableData.state_1!=0">{{tableData.state_1}}</i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="3">
          <span slot="label">
            已完成
            <i class="red" v-if="tableData.state_2&&tableData.state_2!=0">{{tableData.state_2}}</i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="4">
          <span slot="label">
            已取消
            <i class="red" v-if="tableData.state_3&&tableData.state_3!=0">{{tableData.state_3}}</i>
          </span>
        </el-tab-pane>
      </el-tabs>
      <el-table
        :data="tableData.questions"
        @expand="expand"
        :expand-row-keys="expendRow"
        :row-key="row => row.index"
        style="width: 100%"
      >
        <el-table-column property="number" label="稿件订单号" width="95%"></el-table-column>
        <el-table-column property="title" label="标题" width="95%">
          <template slot-scope="scope">
            <a
              target="_blank"
              rel="noopener noreferrer"
              :href="scope.row.publishLink"
            >{{scope.row.title}}</a>
          </template>
        </el-table-column>
        <el-table-column property="content" label="工单描述"></el-table-column>
        <el-table-column property="reason" label="拒绝原因"></el-table-column>
        <el-table-column property="questionState" label="状态"></el-table-column>
        <el-table-column property="questionCreateTime" label="提交时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              size="mini"
              v-show="scope.row.questionState=='未处理'"
              @click="cancel(scope.row.id)"
            >取消工单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination" style="text-align: left;margin-top: 10px;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="count"
        ></el-pagination>
      </div>
    </div>
    <!-- <el-dialog title="工单详情" :visible.sync="dialogVisible" width="40%">
      <el-form ref="form" label-width="100px">
        <el-form-item label="订单状态：" style="width:50%;float:left">{{detail.state}}</el-form-item>
        <el-form-item label="订单编号：" style="width:50%;float:left">{{detail.orderId}}</el-form-item>
        <el-form-item label="工单编号：" style="width:50%;float:left">{{detail.id}}</el-form-item>
        <el-form-item label="文章链接：" style="width:50%;float:left">{{detail.publishLink}}</el-form-item>
        <el-form-item label="处理时间：" style="  clear: both;">{{detail.questionUpdateTime}}</el-form-item>
        <el-form-item label="提交时间：" style="  clear: both;">{{detail.questionCreateTime}}</el-form-item>
        <el-form-item label="工单描述：" style="  clear: both;">{{detail.content}}</el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="cancel">取消工单</el-button>
      </span>
    </el-dialog>-->
  </div>
</template>

<script>
import HeadTop from "../components/HeadTop";
import myAxios from "../myAxios";
export default {
  data() {
    return {
      activeName: "1",
      sousuo: "",
      tableData: [],
      currentRow: null,
      offset: 0,
      limit: 20,
      count: 0,
      currentPage: 1,
      restaurant_id: null,
      expendRow: [],
      username: localStorage.getItem("username"),
      detail: [],
      dialogVisible: false,
      state: 0
    };
  },
  components: {
    HeadTop
  },
  created() {
    this.initData();
  },
  mounted() {},
  methods: {
    async initData() {
      try {
        this.getOrders();
      } catch (err) {
        console.log("获取数据失败", err);
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.offset = (val - 1) * this.limit;
      this.getOrders();
    },
    async getOrders() {
      myAxios
        .get(`/client_user/MyQuestions/v1?username=${this.username}`)
        .then(res => {
          this.tableData = res.data;
          this.count = res.total;
          this.$global_msg.num_2 = res.data.state_1;
        });
      this.loading = false;
    },
    async expand(row, status) {
      if (status) {
        const restaurant = await getResturantDetail(row.restaurant_id);
        const userInfo = await getUserInfo(row.user_id);
        const addressInfo = await getAddressById(row.address_id);

        this.tableData.splice(row.index, 1, {
          ...row,
          ...{
            restaurant_name: restaurant.name,
            restaurant_address: restaurant.address,
            address: addressInfo.address,
            user_name: userInfo.username
          }
        });
        this.$nextTick(() => {
          this.expendRow.push(row.index);
        });
      } else {
        const index = this.expendRow.indexOf(row.index);
        this.expendRow.splice(index, 1);
      }
    },
    handleDetail(index, row) {
      console.log(index, row);
      this.dialogVisible = true;
      this.detail = row;
    },
    cancel(id) {
      myAxios
        .post(
          `/client_user/CancelQuestion/v1?username=${this.username}&questionId=${id}`
        )
        .then(res => {
          console.log(res);
          if (res.code == 0) {
            this.$alert(res.data, "提示", {
              confirmButtonText: "确定"
            }).then(() => {
              this.dialogVisible = false;
              this.changeData();
              this.$parent.$parent.$parent.getNums();
            });
          } else {
            this.$alert(res.data.message, "提示", {
              confirmButtonText: "确定"
            });
          }
        });
    },
    handleClick(tab, event) {
      console.log(tab.index);
      this.state = tab.index;
      this.changeData();
    },
    changeData() {
      myAxios
        .get(
          `client_user/MyQuestions/v1?username=${this.username}&state=${this.state}`
        )
        .then(res => {
          this.tableData = res.data;
          this.count = res.total;
          this.$global_msg.num_2 = res.data.state_1;
        });
      this.loading = false;
    }
  }
};
</script>

<style lang="less">
@import "../style/mixin";
.table_container {
  padding: 20px;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.man-cell {
  width: 200px;
  float: left;
  margin-right: 20px;
}
</style>
